import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.interface';

@Injectable({
    providedIn: 'root'
})
export class ErrorMessageService {

    private errorMessages: { [key: string]: string } = {
        '0': 'error.success',
        '1001': 'error.clientCredentialsRequired',
        '1002': 'error.userCredentialsRequired',
        '1003': 'error.clientNotFound',
        '1004': 'error.invalidClientCredentials',
        '1005': 'error.invalidCredentials',
        '1006': 'error.accountDisabled',
        '1007': 'error.sessionIdRequired',
        '1008': 'error.sessionNotFound',
        '1009': 'error.userNotFound',
        '1010': 'error.otpRequired',
        '1011': 'error.sendOtpFail',
        '1012': 'error.submitOtpFail',
        '1013': 'error.inputFieldsError',
        '1014': 'error.userExisted',
        '1015': 'error.createUserFail',
        '1016': 'error.invalidPolicyOrMemberNumber',
        '1017': 'error.invalidPortalId',
        '1018': 'error.invalidPolicyNumber',
        '1019': 'error.invalidEmail',
        '1020': 'error.inactivePolicy',
        '1021': 'error.accountTemporarilyDisabled',
        '1022': 'error.verifyOtpFirst',
        '1023': 'error.termsConditionsRequired',
        '1024': 'error.accountTemporarilyLocked',
        '1025': 'error.invalidOtp',
        '1032': 'error.noUserProfile',
        '1033': 'error.invalidCredentialsCheck',
        '1034': 'error.policyNotActive',
        '1035': 'error.authCodeNotFound',
        '1036': 'error.emailMismatch',
        '9999': 'error.internalServerError'
    };

    constructor(private translate: TranslateService) { }

    getErrorMessage(errorCode: string): Observable<string> {
        const messageKey = this.errorMessages[errorCode] || 'error.unknownError';
        return this.translate.get(messageKey);
    }

    isSuccessCode(errorCode: string): boolean {
        return errorCode === '0' || errorCode === '1010';
    }

    isSuccessResponse(response: ApiResponse<unknown>): boolean {
        return response.success === true || this.isSuccessCode(response.errorCode);
    }
} 